<template>
  <v-card v-if="form.id">
    <v-toolbar color="yellow darken-3" dark flat>
      <v-toolbar-title>Edit Wholesale</v-toolbar-title>
    </v-toolbar>

    <v-card-text class="space-y-2.5">
      <v-alert v-if="success" type="success" class="pa-0" dense>
        Wholesale updated successfully!
      </v-alert>

      <v-text-field v-model="form.name" hide-details="auto" outlined dense label="Wholesale Name"
                    :error-messages="errors.name" />
      <v-text-field v-model="form.description" hide-details="auto" outlined dense label="Description" />
      <v-switch v-model="form.active" label="Active" />

      <v-divider class="my-4" />

      <v-row v-for="(cond, index) in form.conditions" :key="cond.id || index" align="center">
        <v-col cols="3">
          <v-text-field v-model="cond.min_quantity" outlined hide-details="auto" label="Min Quantity" type="number"
                        dense />
        </v-col>
        <v-col cols="3">
          <v-text-field v-model="cond.discount_percentage" outlined hide-details="auto" label="Discount %" type="number"
                        dense />
        </v-col>
        <v-col cols="3">
          <v-text-field v-model="cond.discount_fixed" outlined hide-details="auto" label="Fixed Discount (₱)"
                        type="number" dense />
        </v-col>
        <v-col cols="3">
          <v-btn text icon @click="removeCondition(cond, index)">
            <v-icon color="red">
              mdi-delete
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-btn class="my-2" text color="primary" @click="addCondition">
        <v-icon left>
          mdi-plus
        </v-icon> Add Condition
      </v-btn>

      <v-divider class="my-4" />
      <div class="flex space-x-2.5">
        <v-btn color="primary" @click="submit">
          Update
        </v-btn>
        <v-btn color="error" @click="clear">
          Close
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from '@/extra-functions/axios.extra'
import { ErrorPopup, SuccessPopup, camelToSnake } from '@/lib/utils'
import { LoadingPopup } from '../../../../lib/utils'

const defaultForm = {
  id: null,
  name: '',
  description: '',
  active: true,
  conditions: [],
}
export default {
  data() {
    return {
      form: { ...defaultForm },
      errors: {},
      success: false,
    }
  },
  methods: {
    populate(data) {
      this.form = {
        id: data.id,
        name: data.name,
        description: data.description,
        active: !!data.active,
        conditions: data.conditions || [],
      }
      this.errors = {}
    },
    clear() {
      this.$emit('close')
      this.form = { ...defaultForm }
    },
    addCondition() {
      this.form.conditions.push({
        min_quantity: 1,
        discount_percentage: 0,
        discount_fixed: 0,
      })
    },
    async removeCondition(cond, index) {
      const isPersisted = !!cond.id
      if (isPersisted) {
        try {
          const token = this.$store.state.auth.token
          await axios(token).delete(`/whole-sales/${this.form.id}/conditions/${cond.id}`)
        } catch {
          ErrorPopup.fire('Failed to delete condition.')
          return
        }
      }
      this.form.conditions.splice(index, 1)
    },
    async submit() {
      this.errors = {}
      try {
        const token = this.$store.state.auth.token
        LoadingPopup.fire()
        const payload = this.toSnakeCase({ ...this.form })
        await axios(token).put(`/whole-sales/${this.form.id}`, payload)
        this.success = true
        this.$emit('updated')
        SuccessPopup.fire({ title: 'Updated', text: 'Wholesale updated successfully.' })
      } catch (e) {
        LoadingPopup.close()
        if (e?.response?.data?.errors) {
          this.errors = e.response.data.errors
          if (e.response.data.errors?.conditions) ErrorPopup.fire(e.response.data.errors?.conditions[0])
          return
        }
        ErrorPopup.fire('Failed to update wholesale.')
      }
    },
    toSnakeCase(obj) {
      const convert = val =>
        Array.isArray(val)
          ? val.map(v => this.toSnakeCase(v))
          : typeof val === 'object' && val !== null
            ? Object.keys(val).reduce((acc, key) => {
              acc[camelToSnake(key)] = convert(val[key])
              return acc
            }, {})
            : val

      return convert(obj)
    },
  },
}
</script>